import React, { useState } from 'react';
import { formatDate } from '../../helpers';
import { isLGPS } from '../../ibsHelper';
import { observer } from 'mobx-react';
import { NotesModal } from './Modals/NotesModal';
import { RemoveModal } from './Modals/RemoveModal';
import { LinkModal } from './Modals/LinkModal';
import { updateExistingMandateCleaned } from '../../Services/IBS/IbsService';

export const ExistingMandateRow = React.memo(observer((props) => {
    let { row, downloadFile, updateIsClean, selectMandate } = props;

    let [notesModalShow, setNotesModalShow] = useState(false);
    const [removeModalShow, setRemoveModalShow] = useState(false);
    const [linkModalShow, setLinkModalShow] = useState(false);
    
    return (<tr className={row.isNew ? "justUploaded" : ""}>
        <td><a onClick={() => setLinkModalShow(true, {
            ...row,
            agrId: row.agrId,
            styleId: row.styleId,
            assetId: row.assetClassId
        })}>{row.mandateId}</a></td>
        <td className='searchable agrId'>{row.agrId}</td>
        <td>{isNaN(row.holdingNavAvg) ? "" : row.holdingNavAvg}</td>
        <td>{isNaN(row.costBps) ? "" : row.costBps}</td>
        <td>{row.normalizedManagerName}</td>
        <td>{row.managerName}</td>
        <td>{row.fundName}</td>
        {isLGPS() ? <td className='centerCell'>{row.isLgpsPoolOption ? 'Yes' : ''}</td> : null}
        <td>{row.statsInfo}</td>
        <td>{row.templateType}</td>
        <td className="uploadLinkTd">
            <div title={row.filePath ? row.filePath.substring(Math.max(row.filePath.lastIndexOf("\\") + 1, 0)) : ""}
                 onClick={() => downloadFile(row)}
                 className={'downloadLink' + (row.filePath === 'broken' ? ' broken' : '')}>{row.filePath ? 'Get file' : ''}</div>
        </td>
        <td>{row.rowId !== 0 ? formatDate(row.dateAdded) : ""}</td>
        {row.rowId !== 0 ? (row.analystComments ?
            <td className='hoverCell' onClick={() => setNotesModalShow(true, {...row})}><i
                class="fas fa-sticky-note"></i></td> :
            <td className='hoverCell' onClick={() => setNotesModalShow(true, {...row})}><i
                class="far fa-sticky-note"></i></td>) : <td></td>}
        <td>{row.status}</td>
        <td className='centerCell'>
            <input type="checkbox" className="uploadCheckBox" checked={row.isClean}
                   onClick={(e) => {
                       updateIsClean(row.mandateRowId, !row.isClean);
                       updateExistingMandateCleaned({
                           ...row,
                           inProcess: false,
                           isClean: row.isClean
                       });
                   }}/>
        </td>
        <td className='centerCell'>
            <input type="checkbox" checked={row.isSelected} onClick={() => selectMandate(row)}/>
        </td>
        <section className="generalModal">
            <NotesModal notesModalShow={notesModalShow} setNotesModalShow={setNotesModalShow} row={row}/>
            <LinkModal linkModalShow={linkModalShow} setLinkModalShow={setLinkModalShow} row={row} updateRow={row}
                       isExisting={true}/>
        </section>
    </tr>)
}));